export const APPLICATION_STATE = 'APPLICATION';

export const NOTICE_TYPES = {
  error: 'error',
  warning: 'warning',
  success: 'success',
} as const;

export const MODALS = {
  navigationHistoryFilter: 'navigationHistoryFilter',
  navigationHistory: 'navigationHistory',
  stationsFilter: 'stationsFilter',
  station: 'station',
  route: 'route',
  carEBoxLocationsClientCards: 'carEBoxLocationsClientCards',
  tariffInfoModal: 'tariffInfoModal',
  subscribe: 'subscribe',
  successSubscribe: 'successSubscribe',
  manageSubscription: 'manageSubscription',
  successDeactivate: 'successDeactivate',
  logIn: 'logIn'
} as const;

export const MENU_ITEMS = {
  map: 'map',
  route: 'route',
  myFleet: 'myFleet',
  history: 'history',
  assistance: 'assistance',
  favouriteStations: 'favouriteStations'
} as const;

export const URL_PARAMS = {
  boundCountries: 'bound-countries',
  activeStation: 'active-station',
} as const;

export const MAP_NAMES = {
  google: 'Google',
  here: 'Here',
} as const;
